import { ActionTypes } from "../../Constants/ActionTypes"
import { setUserEmailId } from "../../Services/localStorageServices";

function loginReducer(state = { userProfile: null }, action) {
    switch (action.type) {
        case ActionTypes.loginActions.SET_USER_PROFILE:
            setUserEmailId(action.data.email);
            return { ...state, userProfile: action.data };
        default:
            return state;
    }
}

export default loginReducer;